import { PermissionKey } from '@evimo/types/enums/permission-key';
import { AuthGuard } from '~/app/auth/guard/AuthGuard';
import { useRolesPage } from './hooks/useRolesPage';
import { RolesPageView } from './RolesPageView';

type RolesPageContainerProps = {
  openCreateOnMount?: boolean;
};

export function RolesPageContainer({
  openCreateOnMount = false,
}: RolesPageContainerProps) {
  const page = useRolesPage({ openCreateOnMount });

  return (
    <AuthGuard requiredPermissions={[PermissionKey.ROLES_READ]}>
      <RolesPageView
        isSuperAdmin={page.isSuperAdmin}
        organizationId={page.organizationId}
        systemRoles={page.systemRoles}
        customRoles={page.customRoles}
        cloneSourceRoles={page.cloneSourceRoles}
        fallbackRoles={page.fallbackRoles}
        isLoading={page.isLoading}
        error={page.error}
        canCreateRole={page.canCreateRole}
        canDeleteRole={page.canDeleteRole}
        userRoleName={page.userRoleName}
        isCreateModalOpen={page.isCreateModalOpen}
        onCreateModalOpenChange={page.onCreateModalOpenChange}
        deletingRole={page.deletingRole}
        onDeletingRoleChange={page.onDeletingRoleChange}
        onViewRole={page.onViewRole}
        onRefresh={page.onRefresh}
        onCreateRole={page.onCreateRole}
        onDeleteRole={page.onDeleteRole}
      />
    </AuthGuard>
  );
}
